// @ts-nocheck
// import InfosBox, { InfosBoxStyles, InfosBoxType } from "@store/Library/Components/Toolkit/InfosBox";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadOrderStatusMappings from "@insite/client-framework/Store/Data/OrderStatusMappings/Handlers/LoadOrderStatusMappings";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code - Start */
import InfosBox, { InfosBoxStyles, InfosBoxType } from "@store/Library/Components/Toolkit/InfosBox";
/* Store Custom Code - End */

interface Props {
    status: string;
}

export interface StoreOrderStatusStyles {
    infosBox?: InfosBoxStyles;
    statusText?: TypographyProps;
    statusTextWrapper?: InjectableCss;
}

export const storeOrderStatusStyles: StoreOrderStatusStyles = {
    statusText: {
        css: css`
            width: 100%;
            text-align: center;
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
};

const styles = storeOrderStatusStyles;

const mappedTypesDefinitions: any = {
    CPT: "success",
    INV: "default",
    PRO: "wraning",
};

const OrderStatus: FC<Props> = ({ status }) => {
    const [boxType, setBoxType] = useState<InfosBoxType>("default");
    const dispatch = useDispatch();
    const orderStatusMappings = useSelector((state: ApplicationState) => getOrderStatusMappingDataView(state));

    useEffect(() => {
        dispatch(loadOrderStatusMappings());
    }, []);

    useEffect(() => {
        const mappedStatus = orderStatusMappings.value?.find(x => x.displayName === status);

        if (mappedStatus) {
            setBoxType(mappedTypesDefinitions[mappedStatus.erpOrderStatus]);
        }
    }, [orderStatusMappings]);

    if (!status) {
        return null;
    }

    return (
        <InfosBox size="tiny" type={boxType} showIcon={false} extendedStyles={styles.infosBox}>
            <Typography {...styles.statusText}>{status}</Typography>
        </InfosBox>
    );
};

export default OrderStatus;
